const reminders = {
  REMINDER_TYPES: {
    WATER: "WATER",
    SLEEP: "SLEEP",
    STEP: "STEP",
    EXERCISE: "EXERCISE",
    DIET: "DIET",
  },
  FREQUENCY_OPTIONS: [
    { label: "Once", value: "once" },
    { label: "Hourly", value: "hourly" },
    { label: "Daily", value: "daily" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
    { label: "Custom", value: "custom" },
  ],
  CUSTOM_FREQUENCY_OPTIONS: [
    { day: "sun" },
    { day: "mon" },
    { day: "tue" },
    { day: "wed" },
    { day: "thu" },
    { day: "fri" },
    { day: "sat" },
  ],
};

export const validateGoals = {
  sleep: {
    min: 1,
    max: 24,
  },
};
export default reminders;
